import React, { useState, useEffect } from "react";
import { NavLink, Link, useNavigate, useLocation } from "react-router-dom";
import { Modal } from "antd";
//import logo from '../Assets/Logo/logo-dark.png';
import { CloseOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import projectApi from "../../API/ProjectAPI";
import { setProjectList } from "../../Reducers/Project/ProjectSlice";
import LogoComponent from "../Pages/Common/LogoComponent";
import {
  LayoutDashboard,
  UsersRound,
  FileCheck2,
  CreditCard,
  UserRound,
  Users,
  Settings2,
  FileStack,
  Mail
} from "lucide-react";

const Layout = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const navigate = useNavigate();
  const { confirm } = Modal;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isServiceMenuOpen, setIsServiceMenuOpen] = useState(false);
  const [iconStyle, setIconStyle] = useState(true);
  const location = useLocation();
  const navigation = location.pathname;
  const projects = useSelector((state) => state.project.list);
  const dispatch = useDispatch();

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleUserMenuToggle = () => {
    setIsUserMenuOpen(!isUserMenuOpen);
  };
  const handleServiceMenuToggle = () => {
    setIsServiceMenuOpen(!isServiceMenuOpen);
  };

  useEffect(() => {
    setIconStyle(false);
  }, []);

  const userImage = useSelector((state) => state.userImage);
  const showLogoutConfirmation = () => {
    confirm({
      title: (
        <div style={{ position: "relative" }}>
          <span>Are you sure you want to logout?</span>
          <CloseOutlined
            style={{
              position: "absolute",
              top: "-8px",
              right: "-10px",
            }}
            onClick={() => {
              Modal.destroyAll();
            }}
          />
        </div>
      ),
      okText: "YES",
      okType: "default",
      cancelText: "NO",
      onOk() {
        handleLogout();
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    setIsLoggedIn(false);
    window.history.replaceState(null, null, "/");
    navigate("/");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await projectApi.getProjectList();
        dispatch(setProjectList(data));
      } catch (error) {
        console.error("Error fetching project list:", error.message);
      }
    };

    fetchData();
  }, [dispatch]);

  return (
    <div
      className="wrapper dashboard"
    >
      <nav className="main-header navbar navbar-expand sidebar-dark-primary">
        {/* <!-- Left navbar links --> */}
        <ul className="navbar-nav">
          <li className="nav-item">
            <a
              className="nav-link"
              data-widget="pushmenu"
              href="#"
              role="button"
            >
              <i className="fas fa-bars"></i>
            </a>
          </li>
        </ul>
        {/* Center navbar content */}
        <ul className="navbar-nav ml-auto">
          <li className="nav-item">
            <div
              className="d-flex align-items-center"
              onClick={() => navigate("/")}
              style={{ cursor: "pointer" }}
            >
              <h3
                className="m-0 fw-bold text-white align-items-center"
                id="main-font"
              >
                ProSlay
              </h3>
            </div>
          </li>
        </ul>

        {/* <!-- Right navbar links --> */}
        <ul className="navbar-nav ml-auto">
          <li className="nav-item me-3">
            <a
              className="nav-link"
              data-widget="fullscreen"
              href="#"
              role="button"
            ></a>
          </li>

          <li className="nav-item d-flex align-items-center">
            <span>
              <img
                src="/assets/Images/userImg.jpg"
                alt=""
                className="img-circle"
              />
            </span>
            <div className="nav-item dropdown d-inline-block">
              <a
                className="nav-link d-flex align-items-center"
                data-toggle="dropdown"
                href="#"
              >
                <h5 className="header-font mb-0 text-white">
                  {localStorage.getItem("userName")}
                </h5>
              </a>
              <div className="dropdown-menu custom-dropdown p-0 text-center">
                <div className="border-bottom">
                  <Link
                    to="/userprofile"
                    className="text-decoration-none logout-font d-block p-1"
                  >
                    PROFILE
                  </Link>
                </div>
                <div>
                  <Link
                    onClick={() => showLogoutConfirmation()}
                    className="text-decoration-none logout-font d-block p-1"
                  >
                    LOGOUT
                  </Link>
                </div>
              </div>
            </div>
          </li>
          {/* <li className="nav-item">
            <a className="nav-link" data-widget="control-sidebar" data-controlsidebar-slide="true" href="#" role="button">
              <i className="fas fa-th-large"></i>
            </a>
          </li> */}
        </ul>
      </nav>
      {/* <!-- /.navbar --> */}

      {/* <!-- Main Sidebar Container --> */}
      <aside className="main-sidebar sidebar-dark-primary elevation-4">
        {/* <!-- Brand Logo --> */}
        <a
          href="#"
          className="brand-link d-flex align-items-center justify-content-center py-2 second-img"
        >
          <LogoComponent inverted={false} size={40} />{" "}
          {/* Added LogoComponent */}
        </a>

        {/* <!-- Sidebar --> */}
        <div className="sidebar">
          {/* <!-- Sidebar Menu --> */}
          <nav className="mt-5">
            <ul
              className="nav nav-pills nav-sidebar flex-column"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              <li className="nav-item">
                <Link
                  to="/dashboard"
                  className={`nav-link ${
                    navigation === "/dashboard" ||
                    navigation === "/Dashboard" ||
                    navigation === "*"
                      ? "active"
                      : ""
                  }`}
                >
                  <LayoutDashboard
                    className="nav-icon me-2"
                    size={20}
                    style={{ color: "#fff" }}
                  />
                  {/* <i className="nav-icon fas fa-tachometer-alt me-2"></i> */}
                  <p>Dashboard</p>
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/clients/0"
                  className={`nav-link ${
                    navigation === "/clients/0" ||
                    navigation.startsWith("/clientview/") ||
                    navigation.startsWith("/clientservicequestion/")
                      ? "active"
                      : ""
                  }`}
                >
                  <UsersRound
                    className="nav-icon me-2"
                    size={20}
                    style={{ color: "#fff" }}
                  />
                  {/* <i className="fas fa-users nav-icon me-2"></i> */}
                  <p>Clients</p>
                </Link>
              </li>
              {/* <li className={`nav-item ${iconStyle ? "menu-open" : ""}`}>
                <Link to="" className={`nav-link ${projects.some(project => navigation === `/legaltools/${project.serviceName.replace(/\s+/g, '')}/${project.serviceId}`) || navigation.startsWith('/singlememberservicequestion/') ? 'active' : ''}`} onClick={() => { setIconStyle(!iconStyle) }}>
                  <i className="nav-icon fa-solid fa-gavel"></i>
                  <p>
                    Legal Tools
                    <i className="right fas fa-angle-left" />
                  </p>
                </Link>
                <ul className="nav nav-treeview">
                  {projects.map(project => (
                    <li key={project.serviceId} className="nav-item">
                      <Link
                        to={`/legaltools/${project.serviceName.replace(/\s+/g, '')}/${project.serviceId}`}
                        className={`nav-link ${navigation === `/legaltools/${project.serviceName.replace(/\s+/g, '')}/${project.serviceId}` ||
                            new RegExp(`/singlememberservicequestion/[^/]+/${project.serviceId}`).test(navigation)
                            ? 'active'
                            : ''
                          }`}
                      >
                        <i className="far fa-circle nav-icon" />
                        <p>{project.serviceName}</p>
                      </Link>
                    </li>
                  ))}
                </ul>
              </li> */}

              {/* <li className="nav-item">
                <Link to='/services' className={`nav-link ${navigation === '/services' || navigation.startsWith('/servicesdetail/') ? 'active' : ''} `}>
                  <i className="fas fa-copy nav-icon me-2"></i>
                  <p>Services</p>
                </Link>
              </li> */}

              {/* <li className="nav-item">
                <Link to='/agreements' className={`nav-link ${navigation === '/agreements' ? 'active' : ''} `}>
                  <i className="fas fa-file-contract nav-icon me-2"></i>
                  <p>Terms</p>
                </Link>
              </li> */}
              <li className={`nav-item ${isMenuOpen ? "menu-open" : ""}`}>
                <Link
                  className={`nav-link ${
                    navigation === "/paymenthistory" ||
                    navigation === "/abandonedcart"
                      ? "active"
                      : ""
                  }`}
                  onClick={handleMenuToggle}
                >
                  {/* <i className="nav-icon fas fa-file-lines" /> */}
                  <FileCheck2
                    className="nav-icon me-2"
                    size={20}
                    style={{ color: "#fff" }}
                  />
                  <p>
                    Reports
                    {/* <i className="right fas fa-angle-left" /> */}
                  </p>
                </Link>
                <ul className="nav nav-treeview">
                  <li className="nav-item">
                    <Link
                      to="/paymenthistory"
                      className={`nav-link ${
                        navigation === "/paymenthistory" ? "active" : ""
                      }`}
                    >
                      {/* <i className="fas fa-money-check-dollar nav-icon me-2"></i> */}
                      <CreditCard
                        className="nav-icon me-2"
                        size={20}
                        style={{ color: "#fff" }}
                      />
                      <p>Payment History</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                <Link
                  to="/newsletterusers"
                  className={`nav-link ${
                    navigation === "/newsletterusers" ? "active" : ""
                  }`}
                >
                  <Mail
                    className="nav-icon me-2"
                    size={20}
                    style={{ color: "#fff" }}
                  />
                  <p>Newsletter</p>
                </Link>
              </li>
                  <li className="nav-item">
                    <Link
                      to="/abandonedcart"
                      className={`nav-link ${
                        navigation === "/abandonedcart" ? "active" : ""
                      }`}
                    >
                      <FileCheck2
                        className="nav-icon me-2"
                        size={20}
                        style={{ color: "#fff" }}
                      />
                      <p>Abandoned Cart</p>
                    </Link>
                  </li>
                </ul>
              </li>

              <li className={`nav-item ${isUserMenuOpen ? "menu-open" : ""}`}>
                <Link
                  className={`nav-link ${
                    navigation === "/userlist" ||
                    navigation === "/userroles" ||
                    navigation.startsWith("/userdetail/")
                      ? "active"
                      : ""
                  }`}
                  onClick={handleUserMenuToggle}
                >
                  {/* <i className="nav-icon fas fa-user-tie" /> */}
                  <UserRound
                    className="nav-icon me-2"
                    size={20}
                    style={{ color: "#fff" }}
                  />
                  <p>
                    Admin
                    {/* <i className="right fas fa-angle-left" /> */}
                  </p>
                </Link>
                <ul className="nav nav-treeview">
                  <li className="nav-item">
                    <Link
                      to="/userlist"
                      className={`nav-link ${
                        navigation === "/userlist" ||
                        navigation.startsWith("/userdetail/")
                          ? "active"
                          : ""
                      }`}
                    >
                      <Users
                        className="nav-icon me-2"
                        size={20}
                        style={{ color: "#fff" }}
                      />
                      {/* <i className="fa-regular fa-circle nav-icon me-2"></i> */}
                      <p>Users</p>
                    </Link>
                  </li>
                  {/* <li className="nav-item">
                    <Link to='/userroles' className={`nav-link ${navigation === '/userroles' ? 'active' : ''} `}>
                      <i className="fa-regular fa-circle nav-icon me-2"></i>
                      <p>User Roles</p>
                    </Link>
                  </li> */}
                </ul>
              </li>

              {/* <li
                className={`nav-item ${isServiceMenuOpen ? "menu-open" : ""}`}
              >
                <Link
                  className={`nav-link ${
                    navigation === "/legaltools" ||
                    navigation.startsWith("/legaltoolsdetail/")
                      ? "active"
                      : ""
                  }`}
                  onClick={handleServiceMenuToggle}
                >
                  <Settings2
                    className="nav-icon me-2"
                    size={20}
                    style={{ color: "#fff" }}
                  />
                  <p>
                    Setup
                  </p>
                </Link>
                <ul className="nav nav-treeview">
                  <li className="nav-item">
                    <Link
                      to="/legaltools"
                      className={`nav-link ${
                        navigation === "/legaltools" ||
                        navigation.startsWith("/legaltoolsdetail/")
                          ? "active"
                          : ""
                      }`}
                    >
                      <FileStack
                        className="nav-icon me-2"
                        size={20}
                        style={{ color: "#fff" }}
                      />
                      <p>Forms</p>
                    </Link>
                  </li>
                </ul>
              </li> */}
            </ul>
          </nav>
        </div>
      </aside>

      {/* <!-- Content Wrapper. Contains page content --> */}
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid px-0">
            <div className="row mb-2 mx-3">
              <div className="col-sm-6">
                {/* <h1 className="m-0">Dashboard</h1> */}
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  {/* <li className="breadcrumb-item"><a href="#">Home</a></li> */}
                  {/* <li className="breadcrumb-item active">Dashboard v1</li> */}
                </ol>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- /.content-header --> */}

        {/* <!-- Main content --> */}

        <section className="content">
          <div className="container-fluid my-5">{children}</div>
        </section>
        {/* <!-- /.content --> */}
      </div>
      {/* <!-- /.content-wrapper --> */}
      <footer className="main-footer text-white d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <LogoComponent inverted={false} size={30} />
          {/* <div
            className="d-flex align-items-center"
            onClick={() => navigate("/")}
            style={{ cursor: "pointer" }}
          >
            <h4 className="m-0 fw-bold" id="main-font">
              ProSlay
            </h4>
          </div> */}
          <strong className="ms-2">© 2025 All Rights Reserved.</strong>
        </div>
      </footer>
      <aside className="control-sidebar control-sidebar-dark"></aside>
    </div>
  );
};

export default Layout;
